module.exports = "https://www.gc-pro.gnp.com.mx/05024985cdf309b1730391143921c206.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-9.png
// module id = 958
// module chunks = 0 1